import { useUpdateEffect } from 'ahooks';
import { Button, Input, InputNumber, message, Modal, Radio, Select, Tag, Tree } from 'antd';
import React, { useEffect, useState } from 'react';
import { ontologyClassifyAdd, ontologyClassifyDel, ontologyClassifyEdit, ontologyList, ontologyListPropertysByEntityId } from '../../../api/inspiration';
import './index.less';
const { Search } = Input;
const { Option } = Select;

export default () => {
    const [expandedKeys, setExpandedKeys] = useState();
    const [checkedKeys, setCheckedKeys] = useState();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [treeData, setTreeData] = useState([])
    const [filterTreeData, setFilterTreeData] = useState(treeData)
    const [currentClassify, setCurrentClassify] = useState()
    const [parentClassify, setParentClassify] = useState()
    // 新增分类的参数
    const [addClassifyParam, setAddClassifyParam] = useState({ parentClassifyName: "", classifyName: '', translateWord: '', classifyGroup: 1, classifyLevel: 1, });
    // 修改分类的参数
    const [editClassifyParam, setEditClassifyParam] = useState();
    // 被删除的属性列表
    const [deletedAttrWords, setDeletedAttrWords] = useState([])
    // 新增的属性列表
    const [addAttrWords, setAddAttrWords] = useState([])
    const [warned, setWarned] = useState(false)

    useEffect(() => {
        setDeletedAttrWords([])
        setAddAttrWords([])
        setPropertys([])
    }, [currentClassify])


    const initTreeData = () => {
        ontologyList().then(res => {
            if (res.error.code == 0) {

                let count = 0
                let temp = []

                let warnText = ''
                res.data.forEach((e1, index1) => {
                    let obj1 = {
                        ...e1,
                        title: e1.node_word,
                        key: `${index1}`,
                        node_group: e1.node_group
                    }
                    count++

                    if (e1.child) {
                        let childList = []
                        e1.child.forEach((e2, index2) => {
                            let obj2 = {
                                ...e2,
                                title: e2.node_word,
                                key: `${index1}-${index2}`
                            }
                            count++
                            if (e2.child) {
                                let childList2 = []
                                e2.child.forEach((e3, index3) => {
                                    let obj3 = {
                                        ...e3,
                                        title: e3.node_word,
                                        key: `${index1}-${index2}-${index3}`
                                    }
                                    count++
                                    childList2.push(obj3)
                                })
                                obj2.children = childList2
                            }
                            childList.push(obj2)
                        })
                        obj1.children = childList
                    } else if (e1.node_word != '其他意向' && e1.node_word != '其他灵感图') {
                        warnText += e1.node_word + ' '
                    }
                    temp.push(obj1)
                });
                if (!warned) {
                    message.warn(`如下根节点分类存在异常：${warnText}`)
                    setWarned(true)
                }
                setTreeData(temp)
                setFilterTreeData(temp)
                list = _.cloneDeep(temp)
            }
        }).catch(e => {
        })
    }

    useEffect(() => {
        initTreeData()
    }, [])


    const onExpand = (expandedKeysValue) => {
        // or, you can remove all expanded children keys.

        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };

    const onCheck = (checkedKeysValue) => {
        setCheckedKeys(checkedKeysValue);
    };

    const onSelect = (selectedKeysValue, info) => {
        setSelectedKeys(selectedKeysValue);
    };

    const [selectedNodeType, setSelectedNodeType] = useState(1)

    useEffect(() => {
        setAddClassifyParam({ ...addClassifyParam, classifyGroup: selectedNodeType })
    }, [selectedNodeType])

    const onSearch = (value) => {
        if (!value) {
            return setFilterTreeData(treeData)
        }
        let temp = _.cloneDeep(treeData)
        temp = temp.map(item => {
            if (item.children) {
                item.children = item.children.map(childrenItem => {
                    if (childrenItem.children) {
                        childrenItem.children = childrenItem.children.filter(thirdItem => {
                            return thirdItem.title.indexOf(value) > -1 || childrenItem.title.indexOf(value) > -1 || item.title.indexOf(value) > -1
                        })
                    }

                    return childrenItem
                })
                item.children = item.children.filter(childItem => {
                    return childItem.title.indexOf(value) > -1 || (childItem.children?.length > 0)
                })

            }
            return item
        })
        temp = temp.filter(item => {
            return item.title.indexOf(value) > -1 || item.children?.length > 0
        })
        setFilterTreeData(temp)
    }

    const [modalVisible, setModalVisible] = useState({ visible: false, type: null }) // 弹窗类型， 0-删除 1-新增 2-修改 3-查看详情

    const handleDelModalOk = async () => {
        if (modalVisible.type == 0) {
            const confirmStatus = window.confirm('分类为高危操作，若仍要删除，点击确定,需要再处理，点击取消')
            if (confirmStatus) {
                const res = await ontologyClassifyDel({ id: currentClassify.id, classifyName: currentClassify.title, force: true })
                if (res.error.code == 0) {
                    message.success('删除成功')
                    initTreeData()
                } else {
                    message.error(res.error.message)
                }
                setModalVisible({ visible: false })
            }
        } else if (modalVisible.type == 2) {
            if (editClassifyParam.title.trim() == '') {
                return message.warn('分类名称不能为空')
            }
            const params = {
                classifyId: editClassifyParam.id,
                classifyName: editClassifyParam.title,
                parentClassifyId: editClassifyParam?.parentId,
                parentClassifyName: editClassifyParam?.parentTitle,
                translation_word: editClassifyParam.translation_word,
                node_group: editClassifyParam.node_group,
                node_level: editClassifyParam.node_level,
                deletedAttrWords,
                addAttrWords,
            }
            ontologyClassifyEdit(params).then(res => {
                if (res.error.code == 0) {
                    if (res.data) {
                        message.success(res.data)
                    } else {
                        message.success('编辑成功')
                    }
                    initTreeData()
                } else {
                    message.error('编辑失败:' + res.error.message)
                }
            }).finally(() => {
                setModalVisible({ visible: false })
            })
        }

    }

    useEffect(() => {
        initSelectedClassify()
    }, [filterTreeData])

    const handleSubmit = () => {
        if (addClassifyParam.classifyName.trim() == '') {
            return message.warn('分类名称不能为空')
        }
        ontologyClassifyAdd(addClassifyParam).then(res => {
            if (res.error.code == 0) {
                message.success('提交成功')
                initTreeData()
            } else {
                message.error(res.error.message)
            }
        }).finally(() => {
            setAddClassifyParam({ parentClassifyName: "", classifyName: '', translateWord: '', classifyGroup: 1, classifyLevel: 1 })
            setModalVisible({ visible: false })
        })
    };

    const initSelectedClassify = () => {

        if (!selectedKeys[0]) {
            return
        }

        try {
            const indexs = selectedKeys[0].split('-')
            switch (indexs.length) {
                case 1:
                    setCurrentClassify(treeData[Number(indexs[0])])
                    setParentClassify(null)
                    break;
                case 2:
                    setParentClassify(treeData[Number(indexs[0])])
                    setCurrentClassify(treeData[Number(indexs[0])].children[Number(indexs[1])])
                    break;
                case 3:
                    setParentClassify(treeData[Number(indexs[0])].children[Number(indexs[1])])
                    setCurrentClassify(treeData[Number(indexs[0])].children[Number(indexs[1])].children[Number(indexs[2])])
                    break;
                default:
                    break;

            }
        } catch (error) {
            setSelectedKeys([])
        }


    }

    useEffect(() => {
        initSelectedClassify()
    }, [selectedKeys])


    const [propertys, setPropertys] = useState([])

    useUpdateEffect(() => {
        if (modalVisible.visible && (modalVisible.type == 3 || modalVisible.type == 2)) {
            let temp = currentClassify
            temp.parentId = parentClassify?.id
            temp.parentTitle = parentClassify?.title
            setEditClassifyParam(temp)
            // 重新打开弹窗时，重置参数
            setDeletedAttrWords([])
            setAddAttrWords([])
            if (!currentClassify.child) {
                ontologyListPropertysByEntityId({ id: currentClassify.id }).then((res) => {
                    if (res.error.code == 0) {
                        setPropertys(res.data)
                    }
                })
            }
        } else {
            setAddClassifyParam({ parentClassifyName: "", classifyName: '', translateWord: '', classifyGroup: 1, classifyLevel: 1 })
            setEditClassifyParam(null)
            setDeletedAttrWords([])
            setAddAttrWords([])
        }
    }, [modalVisible])





    /**
     * 删除属性
     * @param {string} attr_word 
     */
    const handleCloseTag = (attr_word) => {
        // 需要区分删除的是已经存在的还是新增的
        if (addAttrWords.findIndex(value => value == attr_word) > -1) {
            // 删除的是新增的
            let temp = addAttrWords
            _.pull(temp, attr_word);
            setAddAttrWords(temp)
            setPropertys(_.dropWhile(propertys, { 'attr_word': attr_word }))
        } else {
            // 删除的是旧的
            const tempArr = _.concat(deletedAttrWords, attr_word);
            setDeletedAttrWords(tempArr)
        }
    }
    const [inputValue, setInputValue] = useState()

    const handleInputChange = e => {
        setInputValue(e.target.value)
    };

    const handleInputConfirm = () => {
        if (inputValue) {
            let temp;
            if (propertys.findIndex(value => value == inputValue) > -1) {
                message.warn('已存在')
                setInputValue('')
                return
            }
            temp = [...propertys, { top_level_attr_word: inputValue, attr_word: inputValue }];
            const tempArr = _.concat(addAttrWords, inputValue);
            setAddAttrWords(tempArr)
            setPropertys(temp)
            setInputValue('')
        }

    };

    const renderModal = () => {
        if (modalVisible.visible) {
            if (modalVisible.type == 1) {
                return <Modal title="新增分类" visible={true} footer={null} onCancel={() => setModalVisible({ visible: false })}>
                    <div>
                        <label>上级分类名称*：</label>
                        <Input placeholder="上级分类名称,为空则为顶级分类" value={addClassifyParam.parentClassifyName} onChange={(e) => {
                            setAddClassifyParam({
                                ...addClassifyParam,
                                parentClassifyName: e.target.value
                            })
                        }} />
                    </div>
                    <div>
                        <label>分类名称：</label>
                        <Input placeholder="分类名称" value={addClassifyParam.classifyName} onChange={(e) => {
                            setAddClassifyParam({
                                ...addClassifyParam,
                                classifyName: e.target.value
                            })
                        }} />
                    </div>
                    <div>
                        <label>翻译词：</label>
                        <Input placeholder="翻译词" value={addClassifyParam.translateWord} onChange={(e) => {
                            setAddClassifyParam({
                                ...addClassifyParam,
                                translateWord: e.target.value
                            })
                        }} />
                    </div>
                    <div>
                        <label>分类类型：</label>
                        <Select style={{ width: 120 }} defaultValue={1} value={addClassifyParam.classifyGroup} onChange={(value) => setAddClassifyParam({ ...addClassifyParam, classifyGroup: value })}>
                            <Option value={1}>空间分类</Option>
                            <Option value={2}>软装单体</Option>
                            <Option value={4}>意向图</Option>
                            <Option value={3}>硬装单体</Option>
                        </Select>
                    </div>
                    <div>
                        <label>节点等级：&nbsp;&nbsp;</label>
                        <InputNumber placeholder='节点等级' min={0} max={10} value={addClassifyParam.classifyLevel} onChange={(value) => setAddClassifyParam({ ...addClassifyParam, classifyLevel: value })} />
                    </div>
                    <div>
                        <Button type="primary" onClick={() => handleSubmit()}>
                            提交
                        </Button>
                    </div>

                </Modal>
            }

            if (selectedKeys.length == 0) {
                // 如果没有选中分类，则不展示弹窗
                setModalVisible({ visible: false })
                return <></>
            }
            let nodeGroup
            switch (currentClassify.node_group) {
                case 1:
                    nodeGroup = '空间分类'
                    break
                case 2:
                    nodeGroup = '软装单体'
                    break
                case 4:
                    nodeGroup = '意向图'
                    break
                case 3:
                    nodeGroup = '硬装单体'
                    break
                default:
                    nodeGroup = ''
                    break
            }
            switch (modalVisible.type) {
                case 0:
                    return <Modal title="删除分类" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <p>您要删除的分类是：{currentClassify.title}</p>
                    </Modal>
                case 2:
                    return <Modal title="修改分类" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <div>分类名称：<Input value={editClassifyParam?.title} onChange={(e) => setEditClassifyParam({ ...editClassifyParam, title: e.target.value })} /></div>
                        <div>上级分类：<Input value={editClassifyParam?.parentTitle} onChange={(e) => setEditClassifyParam({ ...editClassifyParam, parentTitle: e.target.value })} /></div>
                        <div>翻译词：<Input value={editClassifyParam?.translation_word} onChange={(e) => setEditClassifyParam({ ...editClassifyParam, translation_word: e.target.value })} /></div>
                        <div>分类类型：<Select style={{ width: 120 }} value={`${editClassifyParam?.node_group}`} onChange={(value) => setEditClassifyParam({ ...editClassifyParam, node_group: value })}>
                            <Option value="1">空间分类</Option>
                            <Option value="2">软装单体</Option>
                            <Option value="4">意向图</Option>
                            <Option value="3">硬装单体</Option>
                        </Select></div>
                        <div>节点等级：<InputNumber value={editClassifyParam?.node_level} placeholder='节点等级' min={0} max={10} onChange={(value) => setEditClassifyParam({ ...editClassifyParam, node_level: value })} /></div>
                        {
                            currentClassify.child == null ? <div>
                                <label>关联属性：</label>
                                <Input
                                    type="text"
                                    size="small"
                                    style={{ width: 78 }}
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    onBlur={handleInputConfirm}
                                    onPressEnter={handleInputConfirm}
                                />
                                {propertys.map(item => {
                                    if (item.top_level_attr_word == item.attr_word) {
                                        return <Tag key={item.attr_word} closable onClose={() => handleCloseTag(item.attr_word)}>{item.top_level_attr_word}</Tag>
                                    }
                                    return <Tag key={item.attr_word} closable onClose={() => handleCloseTag(item.attr_word)}>{item.top_level_attr_word}/{item.attr_word}</Tag>
                                })}
                            </div> : <></>
                        }

                    </Modal>
                case 3:

                    return <Modal title="查看详情" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <p>分类名称：{currentClassify.title}</p>
                        <p>上级分类：{parentClassify?.title}</p>
                        <p>翻译词：{currentClassify.translation_word}</p>
                        <p>分类类型：{nodeGroup}</p>
                        <p>节点等级：{currentClassify.node_level}</p>
                        <p><label>关联属性：</label>{propertys.map(item => {
                            if (item.top_level_attr_word == item.attr_word) {
                                return <Tag key={item.attr_word}>{item.top_level_attr_word}</Tag>
                            }
                            return <Tag key={item.attr_word}>{item.top_level_attr_word}/{item.attr_word}</Tag>
                        })}</p>
                        <p>相关近义词:</p>
                        <p>相关词条:</p>
                    </Modal>
                default:
                    break;
            }
        }
        return <></>
    }


    return (
        <div className='ontolyContainer' >
            <Search placeholder="" onSearch={onSearch} style={{ width: 200 }} />
            <Button onClick={initTreeData}>重置</Button>
            <Button onClick={() => setModalVisible({ visible: true, type: 0 })}>删除</Button>
            <Button onClick={() => setModalVisible({ visible: true, type: 1 })}>新增</Button>
            <Button onClick={() => setModalVisible({ visible: true, type: 2 })}>修改</Button>
            <Button onClick={() => setModalVisible({ visible: true, type: 3 })}>查看详情</Button>
            <p></p>
            <Radio.Group value={selectedNodeType} onChange={(e) => { setSelectedNodeType(e.target.value) }} defaultValue={1} buttonStyle="solid">
                <Radio.Button value={1}>空间分类</Radio.Button>
                <Radio.Button value={2}>软装单体</Radio.Button>
                <Radio.Button value={4}>意向图</Radio.Button>
                <Radio.Button value={3}>硬装单体</Radio.Button>
                <Radio.Button value={5}>其他灵感图</Radio.Button>
            </Radio.Group>
            <Tree
                multiple={false}
                checkStrictly={true}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
                treeData={filterTreeData.filter(item => item.node_group == selectedNodeType)}
            />
            {renderModal()
            }
        </div >

    );
};